import environment from "../../environment/environment";
const BASE_URL = `${environment.API}`;

// NOTE: braintree-web 3.100.0's PayPalCheckout component does not expose a
// `tokenize()` method (that belonged to PayPal's deprecated checkout.js
// integration). The current, supported flow requires loading the PayPal JS
// SDK and rendering real PayPal Buttons: `createOrder` calls
// `createPayment()`, and `onApprove` calls `tokenizePayment()`. There is no
// server-only or custom-button-only path around this.

export function prepareBraintreePaypal(clientToken, onReady) {
  braintree.client.create(
    {
      authorization: clientToken,
    },
    function (clientErr, clientInstance) {
      if (clientErr) {
        console.error("Error creating client:", clientErr);
        return;
      }

      let deviceData;

      braintree.dataCollector.create(
        {
          client: clientInstance,
        },
        function (dataCollectorErr, dataCollectorInstance) {
          if (dataCollectorErr) {
            console.error("Error creating dataCollectorInstance:", dataCollectorErr);
            return;
          }
          deviceData = dataCollectorInstance.deviceData;
        }
      );

      braintree.paypalCheckout.create(
        {
          client: clientInstance,
        },
        function (paypalCheckoutErr, paypalCheckoutInstance) {
          if (paypalCheckoutErr) {
            console.error("Error creating paypalCheckoutInstance:", paypalCheckoutErr);
            return;
          }

          paypalCheckoutInstance.loadPayPalSDK(
            {
              currency: "USD",
              intent: "capture",
            },
            function () {
              onReady(paypalCheckoutInstance, () => deviceData);
            }
          );
        }
      );
    }
  );
}

export function renderBraintreePaypalButton(
  paypalCheckoutInstance,
  containerId,
  amount,
  getDeviceData,
  issuePolicy,
  onApproveStart,
  onApproveError
) {
  const container = document.getElementById(containerId);
  if (!container || !window.paypal || !paypalCheckoutInstance) {
    return;
  }

  // Avoid stacking multiple rendered buttons if this runs more than once
  // (e.g. the modal re-opens or paymentType is toggled back to PayPal).
  container.innerHTML = "";

  window.paypal
    .Buttons({
      fundingSource: window.paypal.FUNDING.PAYPAL,
      style: {
        color: "gold",
        shape: "rect",
        height: 45,
        label: "paypal",
      },
      createOrder: function () {
        return paypalCheckoutInstance.createPayment({
          flow: "checkout",
          amount: `${amount}`,
          currency: "USD",
          intent: "capture",
        });
      },
      onApprove: function (data) {
        // The buyer has already finished the PayPal popup at this point -
        // show the loading state and hide the button right away so they
        // can't click it again while tokenizePayment()/issuePolicy() run.
        if (typeof onApproveStart === "function") {
          onApproveStart();
        }
        return paypalCheckoutInstance
          .tokenizePayment(data)
          .then(function (payload) {
            payload.deviceData = getDeviceData();
            issuePolicy(payload);
          })
          .catch(function (err) {
            console.error("Error tokenizing PayPal payment:", err);
            alert("There was an error processing PayPal. Please try again.");
            if (typeof onApproveError === "function") {
              onApproveError();
            }
          });
      },
      onCancel: function () {
        console.log("PayPal payment was cancelled by the user.");
      },
      onError: function (err) {
        console.error("PayPal error:", err);
        alert("There was an error processing PayPal. Please try again.");
      },
    })
    .render(`#${containerId}`);
}
